import { Box, Button, Typography } from '@mui/material'
 const PdfErrorView = ({
  title,
  subtitle,
  onRetry,
  retryBtnText,
}: {
  title: string
  subtitle?: string
  retryBtnText?: string
  onRetry?: () => void
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '420px',
      py: 6,
      px: 3,
      borderRadius: 3,
      bgcolor: 'background.paper',
      mx: 'auto',
      maxWidth: 520,
      textAlign: 'center',
    }}
  >
    {/* Soft Red Circle Icon */}
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: '50%',
        bgcolor: '#fee2e2',
        color: '#dc2626',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 28,
        mb: 2,
      }}
    >
      <i className="fa-solid fa-triangle-exclamation" />
    </Box>

    <Typography variant="h6" fontWeight={700} color="text.primary">
      {title}
    </Typography>

    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ mt: 0.75, mb: 3, maxWidth: 380, lineHeight: 1.5 }}
    >
      {subtitle || 'We encountered an error while rendering this document. Please try again.'}
    </Typography>

    {onRetry && (
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<i className="fa-solid fa-rotate-right" />}
        onClick={onRetry}
        sx={{
          textTransform: 'none',
          borderRadius: 2,
          fontWeight: 600,
          px: 2.5,
          py: 0.8,
        }}
      >
        {retryBtnText}
      </Button>
    )}
  </Box>
)


export default PdfErrorView